
import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import PadoMapComponent from '@/components/ParceDomine/PadoMapComponent.vue';
import PadoMJTurnOrderComponent from '@/components/ParceDomine/PadoMJTurnOrderComponent.vue';
import KimNPCComponent from "@/components/Kimakaan/KimNPCComponent.vue";
import {MJMixin} from '@/mixins/MJMixin';

@Component({
    components: {KimNPCComponent, PadoMJTurnOrderComponent, PadoMapComponent},
})

export default class KimMJComponent extends mixins(MJMixin) {
    created(): void {
        if (this.game.characters) {
            this.npcs = Array(Object.values(this.game.characters).filter(char => {
                return char.isNPC;
            }).length);
            for (let i = 0; i < this.npcs.length; i++) {
                this.npcs[i] = false;
            }
        }
    }
}
